import { DataroomStageName } from '@dataroom/entity/DataroomStageName';
import formatNumber from '@framework/data-helpers/formatters/formatNumber';

export const ACTION_BUTTON_NAME = {
  [DataroomStageName.Live]: 'Go Live',
  [DataroomStageName.InBlackout]: 'Go In Blackout',
  [DataroomStageName.Closed]: 'Close',
};

export const STAGE_MODAL_TITLES = {
  [DataroomStageName.Live]: 'Go Live & Send Invitation Email',
  [DataroomStageName.InBlackout]: 'Go in Blackout',
  [DataroomStageName.Closed]: 'Close Research',
};

export const STAGE_CONFIRM_BUTTON_LABEL = {
  [DataroomStageName.Live]: (investorsCount: number) =>
    `Go Live & Invite ${
      investorsCount > 0 ? `(${ formatNumber(investorsCount) })` : ''
    }`,
  [DataroomStageName.InBlackout]: () => 'Go In Blackout',
  [DataroomStageName.Closed]: () => 'Close Research',
};
